<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import constants from "../../constants";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Student Ledger",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Ledger",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "amount",
          sortable: true,
          label: "Amount Paid",
        },
        {
          key: "pdate",
          sortable: true,
          label: "Date",
        },
        {
          key: "mode",
          sortable: true,
          label: "Payment Method",
        },
        {
          key: "receipt",
          sortable: true,
          label: "Receipt",
        },
        {
          sortable: false,
          key: "actions",
          label: "Action",
        },
      ],
      modeName: "",
      data: {
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },
      edit: {
        id: "",
        amount: "",
        sid: atob(this.$route.params.id),
      },
      delete: {
        id: "",
        sid: atob(this.$route.params.id),
      },
      amountError: "",
      sysConstants: constants,
      id: atob(this.$route.params.id),
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesLedger", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */

    rows() {
      return this.FeesLedger ? this.FeesLedger.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesLedger ? this.FeesLedger.length : 1;
  },
  methods: {
    ...mapActions({
      FetchLedger: "fees/fetchLedger",
      DeletePayment: "fees/deletePayment",
      EditAmount: "fees/editAmtPaid",
      RequestReceipt: "fees/requestReceipt",
      RequestInvoice: "fees/requestInvoice",
      FetchLedgedoc: "fees/fetchLedgedoc",
    }),
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    showEditModal(values) {
      this.edit.id = values.item.id;
      this.edit.amount = values.item.amount;
    },
    showDeleteModal(values) {
      this.delete.id = values.item.id;
    },
    printReceipt(receipt) {
      this.RequestReceipt({ receipt });
    },
    printInvoice(id) {
      this.RequestInvoice({ id });
    },
    addCommas() {
      this.edit.amount = this.thousandSeperator(this.edit.amount);
    },
    resetError() {
      this.amountError = "";
    },
    editAmount(values) {
      this.modal_id = values;
      if (this.edit.amount == "") {
        this.amountError = "Please enter the amount paid";
        return;
      } else {
        this.amountError = "";
      }
      this.EditAmount(this.edit);
      this.resetError();
      this.closeModal(this.modal_id);
    },
    deletePayment(values) {
      this.modal_id = values;
      this.DeletePayment(this.delete);
      this.closeModal(this.modal_id);
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    generateLedgedoc() {
      this.FetchLedgedoc(this.FeesLedger);
    },
    // redirect(value) {
    //   this.$router.push(`/fees/receipt/${btoa(value)}`);
    // },
  },
  created() {
    this.FetchLedger(this.id);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_payments')
        )
      "
    >
      <div class="form-group col-md-12 row">
        <div class="form-group col-md-2"></div>
        <div class="col-md-10">
          <b-button-group class="mb-2 float-end">
            <button v-if="SaveStatus" disabled class="btn btn-sm btn-secondary">
              <b-spinner
                variant="white"
                small
                label="Retrieving..."
              ></b-spinner>
              Retrieving...
            </button>
            <button
              v-else
              @click="generateLedgedoc()"
              class="btn btn-sm btn-secondary"
            >
              <i class="fa fa-print"></i>
              Print PDF
            </button>
          </b-button-group>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <div class="card-body">
            <div class="mt-card-avatar mt-overlay-1 mb-1">
              <img
                v-if="FeesLedger"
                :src="sysConstants.url + 'students/' + FeesLedger.student.photo"
                alt
                class="img-fluid"
                style="border-radius: 70%"
              />
            </div>
            <h5>
              <b><u>Current Information</u></b>
            </h5>
            <h5>
              Name: <b>{{ FeesLedger ? FeesLedger.student.name : "--" }}</b>
            </h5>
            <p>
              Course:
              {{ FeesLedger ? FeesLedger.student.course.short : "--" }} :
              {{ FeesLedger ? FeesLedger.student.class.short : "--" }}
            </p>
            <p>DOB: {{ FeesLedger ? FeesLedger.student.dob : "--" }}</p>
            <p>Gender: {{ FeesLedger ? FeesLedger.student.gender : "--" }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="col-12">
          <div
            class="card"
            v-for="(dat, index) in FeesLedger.payments"
            :key="index"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-9">
                  <h4>
                    {{ FeesLedger.student.course.short }}, {{ dat.class }},
                    {{ dat.year }}
                  </h4>
                </div>
                <div class="col-md-3">
                  <button
                    @click="printInvoice(dat.id)"
                    class="btn btn-sm btn-outline-success float-end"
                  ><i class="fa fa-print"></i> Print Invoice
                    <b-spinner
                      variant="secondary"
                      v-if="SaveStatus"
                      small
                      label="Retrieving..."
                    ></b-spinner>
                  </button>
                </div>
              </div>
              <hr />
              <table width="100%">
                <thead>
                  <tr>
                    <th>Fees</th>
                    <th>Previous Balance</th>
                    <th>Additions</th>
                    <th>Exemptions</th>
                    <th>Payable</th>
                    <th>Paid</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ thousandSeperater(dat.fees) }}</td>
                    <td>{{ thousandSeperater(dat.pbal) }}</td>
                    <td>{{ thousandSeperater(dat.additional) }}</td>
                    <td>{{ thousandSeperater(dat.exemption) }}</td>
                    <td>{{ thousandSeperater(dat.payable) }}</td>
                    <td>{{ thousandSeperater(dat.total_paid) }}</td>
                    <td>{{ thousandSeperater(parseInt(dat.payable) - parseInt(dat.total_paid)) }}</td>
                  </tr>
                </tbody>
              </table>
              <hr>
              <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  class="datatables"
                  :items="dat ? dat.payments : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <span
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_fees_payments')
                        )
                      "
                    >
                      <button
                        v-if="SaveStatus"
                        disabled
                        class="btn btn-sm btn-outline-secondary"
                      >
                        <b-spinner
                          variant="secondary"
                          small
                          label="Retrieving..."
                        ></b-spinner>
                        Retrieving...
                      </button>
                      <button
                        v-else
                        @click="printReceipt(data.item.receipt)"
                        class="btn btn-sm btn-outline-secondary"
                      >
                        <i class="fa fa-print"></i> Receipt Reprint
                      </button>
                    </span>
                    <!-- <b-dropdown size="sm">
                      <template v-slot:button-content>
                        Action
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item>
                        <a
                          href="#"
                          @click="redirect(data.item.id)"
                          class="text-success"
                        >
                          <i class="fa fa-print"></i> Receipt Reprint
                        </a>
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <a
                          href="#"
                          v-b-modal.edit-payment-modal
                          @click="showEditModal(data)"
                          class="text-info"
                          v-if="
                            getCurrentUser.permissions.find((item) =>
                              item.permission.includes('edit_fees_payments')
                            )
                          "
                        >
                          <i class="fa fa-edit"></i> Edit Amount
                        </a>
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <a
                          href="#"
                          v-b-modal.delete-payment-modal
                          @click="showDeleteModal(data)"
                          class="text-danger"
                          v-if="
                            getCurrentUser.permissions.find((item) =>
                              item.permission.includes('delete_fees_payments')
                            )
                          "
                        >
                          <i class="fa fa-trash"></i> Delete Payment
                        </a>
                      </b-dropdown-item>
                    </b-dropdown> -->
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- =============================================== -->
        </div>
      </div>
      <!-- edit modal starts -->
      <b-modal
        id="edit-payment-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_fees_payments')
          )
        "
      >
        <template #modal-title>
          Edit Fees Payment of ({{ edit.amount }})</template
        >
        <div class="form-group mb-2">
          <label>Amount</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="edit.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
          <small class="text-primary">Amount That was Paid</small>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            data-dismiss="modal"
            @click="closeModal('edit-payment-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="editAmount('edit-payment-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete payment starts -->
      <b-modal
        id="delete-payment-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_fees_payments')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">Delete This Fees Payment</h4>
        </template>
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Are you sure you want to delete this fees payment ? Click confirm
              button to Proceed.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-payment-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deletePayment('delete-payment-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
